module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-6.3f91c2b4.svg";